module.exports = __webpack_public_path__ + "static/img/bike.80ca5485.svg";